export default function Diferencial() {
  return (
    <section className="relative py-24 bg-black overflow-hidden">
      {/* Background Effect */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-orange-500 blur-[150px]"></div>
      </div>

      <div className="relative max-w-5xl mx-auto px-6">
        <div className="bg-zinc-950 border-2 border-orange-500 p-12 md:p-16">
          {/* Icon */}
          <div className="flex justify-center mb-8">
            <div className="w-20 h-20 flex items-center justify-center bg-orange-500">
              <i className="ri-star-fill text-4xl text-black"></i>
            </div>
          </div>

          {/* Title */}
          <h2 className="text-3xl md:text-5xl font-black text-white text-center mb-6 leading-tight">
            Não é preset genérico.<br />
            <span className="text-orange-500">É tone de guitarrista pra guitarrista.</span>
          </h2>

          {/* Description */}
          <p className="text-xl text-gray-300 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
            Cada capture foi ajustada pensando em <strong className="text-white">palhetada, palm mute, articulação, peso e definição na mix</strong>.
          </p>

          {/* Features */}
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-orange-500/10 mx-auto mb-4">
                <i className="ri-time-fill text-3xl text-orange-500"></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Economize Tempo</h3>
              <p className="text-sm text-gray-400">
                Sem perder horas ajustando parâmetros
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-orange-500/10 mx-auto mb-4">
                <i className="ri-sound-module-fill text-3xl text-orange-500"></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Som Profissional</h3>
              <p className="text-sm text-gray-400">
                Qualidade de estúdio instantânea
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-orange-500/10 mx-auto mb-4">
                <i className="ri-checkbox-circle-fill text-3xl text-orange-500"></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Pronto pra Usar</h3>
              <p className="text-sm text-gray-400">
                Carregue e comece a tocar
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
